import styled from 'styled-components';

export const Container = styled.header`
  display: flex;
  flex-direction: column;
  margin: 1rem auto;

  .hefesto-input-wrapper__label-wrapper__label::after {
    content: '*';
    color: ${({ theme }) => theme.colors.purple};
  }

  > div {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 1rem auto 1.5rem auto;
    padding: 0;
  }

  & h1 {
    font-weight: 600;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.grayDark3};
  }

  & > .subtitle {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
    font-family: ${({ theme }) => theme.fonts.workSans};
  }
`;
